import { render } from "./SurveyPreview.vue?vue&type=template&id=4aad4c09"
import script from "./SurveyPreview.vue?vue&type=script&lang=js"
export * from "./SurveyPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__